module.exports = __webpack_public_path__ + "img/mini-029.b5aeb18b.jpg";